import React, { useContext, useEffect, useRef, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { GlobalContext } from '../../Contexts/GlobalContext';
import useFetch from '../../CustomHooks/useFetch';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import LanguageIcon from '@material-ui/icons/Language';
import useCustomerSettings from 'CustomHooks/useCustomerSettings';

export default function GuiLanguageSelector(props) {
    const globalContext = useContext(GlobalContext);
    const classes = useStyles();
    const languageMenuRef = useRef(null);
    const [displayLanguageMenu, setDisplayLanguageMenu] = useState(false);//menuyu acip kapamak icin
    const [clickEvent, setClickEvent] = useState(null);
    const getCustomerSettingsHookResponse = useCustomerSettings();
    const [selectedLanguageCode, setSelectedLanguageCode] = useState('en');

    const languages = [
        { code: 'en', name: 'English' },
        /*{ code: 'de', name: 'Deutsch' },
        { code: 'fr', name: 'Français' },
        { code: 'es', name: 'Español' },
        { code: 'zh', name: '中文' },
        { code: 'ru', name: 'Русский' },
        { code: 'ja', name: '日本語' },
        { code: 'it', name: 'İtaliano' },
        { code: 'sv', name: 'Svenska' },*/
        { code: 'tr', name: 'Türkçe' },
    ];

    useEffect(
        () => {
    
            //console.log(getCustomerSettingsHookResponse);
            if(getCustomerSettingsHookResponse.defaultLanguage){
                //ilk once localStorage'a bakiyorum, eger kullanici daha once secmis ise onu
                //kullaniyorum, yoksa serverdan gelen degeri kullaniyorum
                let languageCode='';
                if (localStorage.getItem('ht_adm_cs') != null) {
                    let customerSettings = JSON.parse(localStorage.getItem('ht_adm_cs'));    
                    if(customerSettings.selectedGuiLanguage) {
                        languageCode = customerSettings.selectedGuiLanguage;
                    }
                   
                    
                }
                if (languageCode=='') {
                    //serverdan geleni set et
                    languageCode = getCustomerSettingsHookResponse.defaultLanguage;
                    if(languageCode != 'tr') {
                        //turkce disindaki butun diller icin ingilizceyi sectiriyorum
                        languageCode = 'en'; 
                    }
                }
                globalContext.dispatchMethod(
                    {
                        type: 'SET_SELECTED_GUI_LANGUAGE',
                        value: languageCode,
                    }
                )
            }
            
        },[getCustomerSettingsHookResponse] 
    )

    useEffect(
        () => {
            if (displayLanguageMenu) {
                document.addEventListener('click', clickListener);
            }

            return () => document.removeEventListener('click', clickListener)
        }, [displayLanguageMenu]
    )

    



    const clickListener = (e) => {
        if (languageMenuRef.current == null) {
            setDisplayLanguageMenu(false);
        }
        else {
            if (!languageMenuRef.current.contains(e.target)) {
                setDisplayLanguageMenu(false);
            }
        }
    }

    

    const changeLanguage = (languageCode) => {
        console.log(languageCode);
        
        setSelectedLanguageCode(languageCode.toUpperCase());

        setDisplayLanguageMenu(false);

        globalContext.dispatchMethod(
            {
                type: 'SET_SELECTED_GUI_LANGUAGE',
                value: languageCode,
            }
        )

        let customerSettings = JSON.parse(localStorage.getItem('ht_adm_cs'));     
        customerSettings = {
            ...customerSettings,
            selectedGuiLanguage : languageCode,
        }
        localStorage.setItem('ht_adm_cs', JSON.stringify(customerSettings));
    }


  

 

    return (
        <React.Fragment>
            {
                //globalContext.globalState.availableLanguages && globalContext.globalState.availableLanguages.length > 0 &&
                <div style=
                    {{
                        display: 'flex',
                        alignItems: 'center',
                        position: 'relative',
                        color: '#546e7a',
                        marginRight: '20px',
                        cursor: 'pointer',
                    }}
                    onClick={() => {
                        if (displayLanguageMenu == false)
                            setDisplayLanguageMenu(true)
                    }
                    }
                >
                    <Typography variant="body1">
                        {globalContext.globalState.selectedGuiLanguage.toUpperCase()}
                    </Typography>
                    <ExpandMoreIcon></ExpandMoreIcon>

                    {
                        displayLanguageMenu ?
                            <div ref={languageMenuRef} className={classes.languagesDiv}>
                                {
                                    languages.map(
                                        lang =>
                                            <div key={lang.code} onClick={() => { changeLanguage(lang.code); setDisplayLanguageMenu(false); }}>{lang.name}</div>
                                    )
                                }
                            </div>
                            : null
                    }
                </div>

            }
        </React.Fragment>
    )
}

const useStyles = makeStyles({
    root: {
    },
    languagesDiv: {
        zIndex: 1000,
        position: 'absolute',
        fontSize: '1.2rem',
        top: '40px',
        left: '-60px',
        boxShadow: '0px 5px 5px -3px rgba(0,0,0,0.2), 0px 8px 10px 1px rgba(0,0,0,0.14), 0px 3px 14px 2px rgba(0,0,0,0.12)',
        padding: '10px',
        backgroundColor: 'white',
        '& > div:nth-child(n+1)': {
          marginTop: '10px',
        }
      },
});